import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  eventDetailsById: {}  // { [eventID]: eventDetails }
};

export const eventSlice = createSlice({
  name: 'eventData',
  initialState,
  reducers: {
    // Set or update event details for a specific eventID
    setEventDetails: (state, action) => {
      const { eventID, eventDetails } = action.payload;
      if (!eventID) return;
      state.eventDetailsById[eventID] = eventDetails || {};
    },

    // Remove event details for a specific eventID
    clearEventDetails: (state, action) => {
      const { eventID } = action.payload;
      delete state.eventDetailsById[eventID];
    },

    // Clear all event details
    clearAllEventDetails: (state) => {
      state.eventDetailsById = {};
    }
  }
});

// Export actions
export const {
  setEventDetails,
  clearEventDetails,
  clearAllEventDetails
} = eventSlice.actions;

// Export reducer
export default eventSlice.reducer;

// Selector to get event details by eventID
export const selectEventDetailsById = (state, eventID) =>
  state.eventcartdata.eventDetailsById[eventID] || {};
export const selectAllEventDetails = (state) => state.eventcartdata.eventDetailsById;
